import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addVendor } from 'slices/vendorSlice';
import { vendorSelector } from 'slices/vendorSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/vendorSlice';
import toast from 'react-hot-toast';
import { updateVendor } from 'slices/vendorSlice';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { cdn } from 'constants/common';
import { UploadButton } from '@bytescale/upload-widget-react';
import { ProfilePicture } from 'components/common/ProfilePicture';
import { fetchVendorsListPage } from 'slices/vendorSlice';
import InterpreterRate from 'components/type/InterpreterRate';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from "components/common/Select";
import { fetchLanguages } from 'slices/languageSlice';

const apiService = new Api();
const AddVendorForm = ({ item, handleClose, callback }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm();
  const { error, loader } = useSelector(vendorSelector);
  const [status, setStatus] = useState(1);
  const fileInputRef = React.useRef(null);
  const [localImage, setLocalImage] = React.useState('')

  const [languageState, setLanguageState] = useState([]);

  const resetFileInput = () => {
    setLocalImage("")
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    setValue('name', item?.name || '')
    setValue('email', item?.email || '')
    setValue('password', item?.address_line1 || '')
    setValue('password_confirmation', item?.password_confirmation || '')
    setValue("image", item?.image || '')
    setStatus((typeof (item?.status) == "number") ? item?.status : 1)

    const languagesSource = item?.vendor_languages || item?.languages;
    if (languagesSource) {
      const languages = languagesSource.map(lang => ({
        label: lang.language?.name || lang.name || "",
        value: lang.language?.id || lang.id || ""
      }));
      setLanguageState(languages);
      setValue('language_ids', languages.map(l => l.value));
    } else {
      setLanguageState([]);
      setValue('language_ids', []);
    }

    return () => {
      dispatch(setError({}))
      setValue("name");
      setValue("email");
      setValue("password");
      setValue("password_confirmation");
      setValue("image", '')
      setStatus(1)
      setLanguageState([])
      setValue('language_ids', [])
      resetFileInput()
      clearErrors("password_confirmation")
    }


  }, [item])


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message)
      dispatch(fetchVendorsListPage())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message);
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}));
    data = {
      ...data,
      status,
    };

    const formData = new FormData();

    for (let key in data) {
      if (key === "image") {
        if (data.image && typeof data.image === "object") {
          formData.append("image", data.image);
        } else if (typeof data.image === "string") {
          formData.append("existingImage", data.image);
        }
      } else {
        formData.append(key, data[key]);
      }
    }

    if (item?.id) {
      dispatch(updateVendor(formData, item?.id, submitCallback));
    } else {
      dispatch(addVendor(formData, submitCallback));
    }
  };
  const options = {
    apiKey: "free",
    maxFileCount: 1
  };

  const filteredLanguagesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchLanguages(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((language) => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>


        <div className="row-primary">
          <h2>Profile Picture</h2>

          <div className='Upload_wrapper'>
            {(localImage || item?.image) &&
              <div className='image_preview'>
                <ProfilePicture imageUrl={localImage || cdn + item?.image} />
              </div>
            }
            <div className="w-100">
              <Controller
                name="image"
                control={control}
                render={({ field }) =>
                (
                  <UploadButton options={options}
                    onComplete={files => {
                      const file = files[0];
                      setLocalImage(file?.fileUrl)
                      field.onChange(file?.originalFile?.file)
                    }}>
                    {({ onClick }) =>
                      <button type='button' onClick={onClick}>
                        <i className="fa-solid fa-camera"></i>&nbsp;&nbsp;
                        <span>Upload New</span>
                      </button>
                    }
                  </UploadButton>
                )}
              />

              {error?.errors?.image?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="row-primary">
          <h2>Agency Name *</h2>
          <Controller
            name="name"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Agency Name' required {...field} />}
          />
        </div>

        <div className="row-primary">
          <h2>Email *</h2>
          <div className="w-100">
            <Controller
              name="email"
              control={control}
              rules={{
                required: true,
              }}
              render={({ field }) => <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" name='email'
                required
                pattern={
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                }
                placeholder="Email Address"
                {...field} />}
            />
            {error?.errors?.email?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>


        <div className="row-primary">
          <h2>Password {item?.id ? "" : "*"}</h2>
          <div className="w-100">
            <input className="input-in type_inp" type="password" {...register("password")} name='password' placeholder="Password" required={item?.id ? false : true} />
            {error?.errors?.password?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Confirm Password {item?.id ? "" : "*"}</h2>
          <div style={{ width: "100%" }}>
            <input className="input-in type_inp" type="password"
              {...register("password_confirmation", {
                validate: (value) =>
                  value === watch("password") || "Passwords do not match",
              })}
              name='password_confirmation'
              required={item?.id ? false : true}
              placeholder="Confirm Password" />

            {errors?.password_confirmation &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.password_confirmation?.message} />
              </div>
            }
            {error?.errors?.password_confirmation?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Select Languages *</h2>
          <Controller
            name="language_ids"
            required
            rules={{
              required: "Languages must be specified",
            }}
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement="auto"
                    isMulti
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={languageState}
                    loadOptions={filteredLanguagesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setLanguageState(selected);
                      field.onChange(selected.map((opt) => opt.value));
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.language_ids?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.language_ids?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        {/* <InterpreterRate control={control} error={error} errors={errors} item={item} dispatch={dispatch} setValue={setValue} watch={watch} isClient={false} /> */}

        <div className="row-primary flex-row align-items-center" style={{ alignItems: "center" }}>
          <h2 className='mt-0'>Status</h2>
          <CustomSwitch
            labelText="active"
            checked={status == 1 ? true : false}
            handleChange={(checked) => setStatus(checked ? 1 : 0)}
          />
        </div>

        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <SubmitButton
            btnText={item?.id ? "Update" : "Create"}
            loader={loader}
          />
        </div>
      </form>

    </div>
  )
}

const AddVendor = ({ item, onClose, callback, }) => {
  return (
    <div class={`modal fade`} id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Vendor</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddVendorForm item={item} handleClose={onClose} callback={callback} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddVendor
